export default "__VITE_ASSET__DgCq6lmg__"